import { Head_2, Highlight, Shadow, Wrapper_ShadHight } from '../Typography';

const HeaderPages = ({ title, shadow }) => {
  return (
    <Wrapper_ShadHight>
      <Head_2>
        <Highlight>{title.split(' ')[0]}</Highlight> {title.split(' ')[1]}
        <Shadow>{shadow}</Shadow>
      </Head_2>
    </Wrapper_ShadHight>
  );
};

export default HeaderPages;
